module.exports = __webpack_public_path__ + "static/media/AS_icon_toolbox.ee24b953.svg";